const LIMITE_PREGUNTAS = 20

export const isConversacion = consultaBarbeibot => {
  if (!consultaBarbeibot) return false
  if (!consultaBarbeibot.interacciones) return false
  if (!Array.isArray(consultaBarbeibot.interacciones)) return false
  return true
}

export const getResumenConsulta = consultaBarbeibot => {
  if (!consultaBarbeibot) return '--'
  if (consultaBarbeibot.pregunta) return consultaBarbeibot.pregunta
  if (!consultaBarbeibot.interacciones) return '--'
  if (!Array.isArray(consultaBarbeibot.interacciones)) return '--'
  if (consultaBarbeibot.interacciones.length === 0) return '--'
  const primeraInteraccion = consultaBarbeibot.interacciones[0]
  if (!primeraInteraccion.contenido) return '--'
  return primeraInteraccion.contenido || '--'
}

export const getConversacionesRestantes = conversacionBarbeibot => {
  if (!conversacionBarbeibot) return 0
  const numPreguntas = (conversacionBarbeibot.interacciones || []).length
  return Math.max(0, LIMITE_PREGUNTAS - numPreguntas)
}
